import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

interface ConfirmActionDialogProps {
  open: boolean;
  title: string;
  confirmLabel: string;
  loadingLabel: string;
  isLoading: boolean;
  /** Disables the confirm button (in addition to the loading state). */
  confirmDisabled: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

/**
 * Shared chrome for a confirm/cancel action dialog: a title, arbitrary body
 * content, a Cancel button, and an error-colored submit button that shows a
 * loading label and is disabled while pending or when {@link confirmDisabled}.
 */
const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  open,
  title,
  confirmLabel,
  loadingLabel,
  isLoading,
  confirmDisabled,
  onClose,
  onConfirm,
  children,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="error"
        disabled={confirmDisabled || isLoading}
      >
        {isLoading ? loadingLabel : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmActionDialog;
